"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEncodedTypeOf = isEncodedTypeOf;
function isEncodedTypeOf(object, type) {
    return typeof object === "object" &&
        object.hasOwnProperty("___type") &&
        object.___type === type;
}
//# sourceMappingURL=encoded-data.js.map